"use strict";

const watermarkHelper = require("../dashboard-builder/formConfig/watermarkHelper");

module.exports = function ($scope, $state, $uibModalInstance, department, ReportConfig, BuilderDataService, $translate, toast, departmentReportConfig, Upload, dialog, $timeout) {
    var _this = this;
    
    this.activeTab = 0;

    this.apiURL = require("../server").server;
    this.department = department;

    this.schemaOptions = ["schema1", "schema2", "custom"];
    this.array = [
        { value: "schema1", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FORMAT_RPT_O1") },
        { value: "schema2", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FORMAT_RPT_O2") },
        { value: "custom", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FORMAT_RPT_O3") },
    ];

    this.photosPerRow = [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
    ];

    this.optGrid = [
        { value: "grid-of-1", text: "1" },
        { value: "grid-of-2", text: "2" },
        { value: "grid-of-3", text: "3" },
        { value: "grid-of-4", text: "4" },
        { value: "grid-of-5", text: "5" },
    ];

    this.maxHeightPhotoInForm = [
        { value: "2.5", text: "2.5" },
        { value: "5", text: "5" },
        { value: "7.5", text: "7.5" },
        { value: "10", text: "10" },
    ];

    this.optInterline = [
        { value: "interline1px", text: "1" },
        { value: "interline3px", text: "3" },
        { value: "interline5px", text: "5" },
        { value: "interline10px", text: "10" },
    ];

    this.fontSize = [
        { value: "sm", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FONT_SIZE_O1") },
        { value: "md", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FONT_SIZE_O2") },
        { value: "lg", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FONT_SIZE_O3") },
    ];

    this.pageSizes = [
        { value: "A4", text: "A4" },
        { value: "A5", text: "A5" },
        { value: "A3", text: "A3" },
        { value: "legal", text: "Legal" },
        { value: "letter", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.PAGE_SIZE_LETTER") },
    ];
    this.pageOrientations = [
        { value: "portrait", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.PAGE_ORIENTATION_2") },
        { value: "landscape", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.PAGE_ORIENTATION_1") },
    ];

    // console.log('ReportConfig 2')
    if (departmentReportConfig) {
        // console.log('ReportConfig 2.1 en if', departmentReportConfig);
        this.reportConfig = departmentReportConfig;
        if (this.reportConfig.validate == undefined) { //para compatibilidad hacia reportes cuando no existia el seteo
            // console.log('this.reportConfig.validate == undefined')
            this.reportConfig.validate = true;
            this.reportConfig.validate_title = true;
            this.reportConfig.validate_state = true;
            this.reportConfig.validate_fields = false;
        }
    } else {
        // console.log('ReportConfig 2.1 en  else')
        this.reportConfig = BuilderDataService.getReportConfigInit();
        // console.log('this.reportConfig 2.1', this.reportConfig)
    }

    this.reportConfig.interline = this.reportConfig.interline || "interline1px";
    this.reportConfig.maxHeightPhotoInForm = this.reportConfig.maxHeightPhotoInForm || "5";
    this.reportConfig.gridOf = this.reportConfig.gridOf || "grid-of-1";
    this.reportConfig.customFooter = this.reportConfig.customFooter || " ";
    this.reportConfig.customHeader = this.reportConfig.customHeader || " ";
    this.reportConfig.pageOrientation = this.reportConfig.pageOrientation || "portrait";
    this.reportConfig.pageSize = this.reportConfig.pageSize || "A4";


    if (!this.reportConfig.reportSchema) {
        this.reportConfig.reportSchema = "custom";
    }

    if (!this.reportConfig.fontSize) {
        this.reportConfig.fontSize = "md";
    }

    if (this.reportConfig.logo) {
        this.reportLogo = this.reportConfig.logo;
    }
    // MAXIMO PERMITIDO 4
    if (!this.reportConfig.photosPerRow || this.reportConfig.photosPerRow > 4) {
        this.reportConfig.photosPerRow = 4;
    }

    watermarkHelper.ensure(this.reportConfig);
    this.showWatermarkPanel = false;
    this.showLogoPanel = false;

    this.closeAssetPanels = () => {
        _this.showWatermarkPanel = false;
        _this.showLogoPanel = false;
    };

    this.openLogoPanel = ($event) => {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        _this.showWatermarkPanel = false;
        _this.showLogoPanel = true;
    };

    this.closeLogoPanel = () => {
        _this.showLogoPanel = false;
    };

    this.openWatermarkPanel = ($event) => {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        _this.showLogoPanel = false;
        _this.showWatermarkPanel = true;
    };

    this.closeWatermarkPanel = () => {
        _this.showWatermarkPanel = false;
    };

    this.updateWatermarkHtml = () => {
        watermarkHelper.updateHtml(_this.reportConfig, _this.apiURL);
    };

    this.setWatermarkPosition = (position) => {
        _this.reportConfig.watermark.position = position;
        _this.updateWatermarkHtml();
    };

    this.clearWatermarkImage = () => {
        _this.reportConfig.watermark.url = null;
        _this.updateWatermarkHtml();
    };

    this.watermarkPreviewSrc = () => {
        return watermarkHelper.getSrc(_this.reportConfig.watermark.url, _this.apiURL);
    };

    this.watermarkPreviewStyle = () => {
        return watermarkHelper.getImageStyle(_this.reportConfig.watermark);
    };

    this.getLogoUrl = () => {
        if (!_this.reportLogo) {
            return "";
        }
        return (_this.apiURL.replace("/api", "") || "") + _this.reportLogo;
    };

    watermarkHelper.bindThumbStatus(_this, $scope, $timeout);

    this.copyLogoUrl = ($event) => {
        if ($event) {
            $event.preventDefault();
        }
        const url = _this.getLogoUrl();
        if (!url) {
            return;
        }
        const showCopied = () => {
            toast.success($translate.instant("DASHBOARD.DASH_FORM.REPORT.URL_COPIED"));
        };
        const showError = () => {
            toast.error($translate.instant("DASHBOARD.DASH_FORM.REPORT.URL_COPY_ERROR"));
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(() => {
                $timeout(showCopied);
            }).catch(() => {
                $timeout(showError);
            });
            return;
        }
        try {
            const input = document.createElement("textarea");
            input.value = url;
            input.setAttribute("readonly", "");
            input.style.position = "absolute";
            input.style.left = "-9999px";
            document.body.appendChild(input);
            input.select();
            const ok = document.execCommand("copy");
            document.body.removeChild(input);
            if (ok) {
                showCopied();
            } else {
                showError();
            }
        } catch (e) {
            showError();
        }
    };

    $scope.uploadWatermarkFile = function (file) {
        if (!file) {
            return;
        }

        _this.markWatermarkThumbLoading();

        var unique = Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        unique += Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);

        var ext = file.name.slice(
            file.name.lastIndexOf(".") + 1,
            file.name.length
        );
        var apiURL = require("../server").server;
        file.upload = Upload.upload({
            url: apiURL + "/containers/" + $state.params.departmentId + "/upload",
            data: { file: file },
            picFile: Upload.rename(file, unique + "." + ext),
        });

        file.upload.then(function (response) {
            toast.success(
                $translate.instant("DASHBOARD.DASH_FORM.REPORT.LBL_LOGO_OK")
            );
            _this.reportConfig.watermark.url =
                "/api/containers/" +
                response.data.result.files.file[0].container +
                "/download/" +
                response.data.result.files.file[0].name;
            _this.updateWatermarkHtml();
        }, function () {
            _this.watermarkThumbStatus = "error";
        });
    };

    $scope.uploadFiles = function (file, errFile) {
        if (file) {
            _this.markLogoThumbLoading();
            _this.reportConfig.logo = file.name;

            var unique = Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
            unique += Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);

            var ext = file.name.slice(
                file.name.lastIndexOf(".") + 1,
                file.name.length
            );
            var apiURL = require("../server").server;
            file.upload = Upload.upload({
                // url: apiURL + "/containers/" + _this.form.tenantId + "/upload",
                url: apiURL + "/containers/" + $state.params.departmentId + "/upload",
                data: { file: file },
                picFile: Upload.rename(file, unique + "." + ext),
                success: function (res) {
                    console.log(res);
                },
            });

            file.upload.then(function (response) {
                toast.success(
                    $translate.instant("DASHBOARD.DASH_FORM.REPORT.LBL_LOGO_OK")
                );
                _this.reportLogo =
                    "/api/containers/" +
                    response.data.result.files.file[0].container +
                    "/download/" +
                    response.data.result.files.file[0].name;
                _this.reportConfig.logo = _this.reportLogo;
            }, function () {
                _this.logoThumbStatus = "error";
            });
        }
    };

    _this.loadEditorHTML = function (scroll) {
        if (!_this.reportConfig.tableLayout) {
            _this.reportConfig.customHeader = ' ';
            _this.reportConfig.customFooter = ' ';
            return
        };

        $timeout(function () {
            if (!scroll) {
                $timeout(() => {
                    // console.log('scrollDown')
                    $scope.scrollDown();
                }, 150);
            }
        }, 100);
    };

    // Function to scrollDown
    $scope.scrollDown = function () {
		var container = document.getElementById('scrollContainer');
		container.scrollTop = container.scrollHeight;
    };

    angular.element(document).ready(_this.loadEditorHTML);
    this.close = function() {
        // console.log('close');
        $uibModalInstance.close({
            save: false,
        });
    };

    this.confirm = function() {
        // console.log('confirm')
        _this.updateWatermarkHtml();

        this.errorMessage(
            $translate.instant("DASHBOARD.DASH_FORM.REPORT.DEPT_REPORT_DIALOG.TITLE"),
            // "Reportes: Plantilla",
            $translate.instant("DASHBOARD.DASH_FORM.REPORT.DEPT_REPORT_DIALOG.BODY2"),
            // "La configuración de reporte de los formularios preexistentes no se modificará automáticamente. Los cambios deberán realizarse manualmente."
        );
        
        $uibModalInstance.close({
            save: true,
            departmentReportConfig: _this.reportConfig,
            department: _this.department,
        });
    }

    this.errorMessage = function(title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: 'md'
        });
    }
}
// ];
